module.exports = __webpack_public_path__ + "group-12.svg?2475310ad15c3669798a507586c3a402";